module.exports = __webpack_public_path__ + "assets/e42ab1866b0668f6203dd8ee95384fcd.mp3";